import { render, staticRenderFns } from "./PackageKidsApprovedAdvance.vue?vue&type=template&id=16f1ca10&scoped=true"
import script from "./PackageKidsApprovedAdvance.vue?vue&type=script&lang=js"
export * from "./PackageKidsApprovedAdvance.vue?vue&type=script&lang=js"
import style0 from "./PackageKidsApprovedAdvance.vue?vue&type=style&index=0&id=16f1ca10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1ca10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f1ca10')) {
      api.createRecord('16f1ca10', component.options)
    } else {
      api.reload('16f1ca10', component.options)
    }
    module.hot.accept("./PackageKidsApprovedAdvance.vue?vue&type=template&id=16f1ca10&scoped=true", function () {
      api.rerender('16f1ca10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageKidsApprovedAdvance.vue"
export default component.exports